import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  max-width: 1800px;
  margin: 0 auto;
  padding: 8px 40px 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0;
  background: #fff;
  width: 100%;
`;

export const ImpersonationBanner = styled.div`
  background-color: #e03131;
  color: #fff;
  padding: 12px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font: normal 1.125rem / 28px Inter, sans-serif;
  border-radius: 8px;
  border: 1px solid #e27808;
  width: 100%;

  p {
    text-align: left;
    margin: 0;
    padding: 0;

    @media (width >= 768px) {
      text-align: center;
    }
  }

  a {
    color: #fff;
    text-decoration: none;
    background: #5b1313;
    border-radius: 8px;
    height: 32px;
    padding: 6px 16px;
    gap: 8px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    display: flex;
  }

  @media (width >= 768px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    gap: 16px;
  }
`;
